import { Link } from 'react-router-dom';
import AnimatedSection from './AnimatedSection';

const EVENT_TYPES = [
  {
    title: 'Agricultural Shows',
    route: '/agricultural-shows',
    image: '/images/crowd-festival-dinosaur-enthusiasts-007.jpeg',
    icon: '🌾',
    description: 'All-day roaming activation built to move crowds across the showgrounds.',
  },
  {
    title: 'Festivals & Events',
    route: '/festivals-and-community-events',
    image: '/images/colorful-performance-outdoor-fun-006.jpeg',
    icon: '🎪',
    description: 'Highly visual encounters and roaming characters that create instant energy.',
  },
  {
    title: 'Schools',
    route: '/schools-and-kinders',
    image: '/images/jurassic-jack-dino-interaction-025.jpeg',
    icon: '🏫',
    description: 'Fun, age-appropriate learning that sparks curiosity and imagination.',
  },
  {
    title: 'Kinders',
    route: '/schools-and-kinders',
    image: '/images/happy-child-dinosaur-mask-021.jpeg',
    icon: '🧒',
    description: 'Gentle discovery experiences designed for our youngest adventurers.',
  },
  {
    title: 'Science Week & Libraries',
    route: '/national-science-week',
    image: '/images/dinosaur-exhibit-library-event-032.jpeg',
    icon: '📚',
    description: 'Mobile paleontology experiences: fossil talks, dig activities and discovery.',
  },
  {
    title: 'Charity & Community',
    route: '/charity-and-community',
    image: '/images/dinosaur-show-fun-engagement-030.jpeg',
    icon: '❤️',
    description: 'Family-friendly entertainment that supports community connection.',
  },
  {
    title: 'Private Events',
    route: '/contact',
    image: '/images/jurassic-jack-dino-party-2023-044.jpeg',
    icon: '🎉',
    description: 'Birthdays, weddings and private celebrations with a prehistoric twist.',
  },
  {
    title: 'Corporate',
    route: '/contact',
    image: '/images/jurassic-jack-jeep-performance-038.jpeg',
    icon: '🏢',
    description: 'Team building, activations and corporate events that stand out.',
  },
];

const EventTypeCards = () => {
  return (
    <section className="py-20 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection className="text-center mb-14">
          <p className="font-mono text-sm uppercase tracking-[0.2em] text-orange-vibrant mb-2">
            Choose Your Event Type
          </p>
          <h2 className="text-4xl md:text-5xl font-display text-charcoal">
            Where Are You Bringing The <span className="text-orange-vibrant">Adventure</span>?
          </h2>
          <p className="mt-4 text-charcoal/60 max-w-2xl mx-auto">
            Choose the option that fits your audience — we tailor each activation to your space, schedule and crowd size.
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {EVENT_TYPES.map((event, i) => (
            <AnimatedSection key={event.title} delay={i * 0.08}>
              <Link
                to={event.route}
                className="group relative block rounded-xl overflow-hidden aspect-[4/5]
                           transition-all duration-300
                           hover:-translate-y-2 hover:shadow-amber-glow hover:rotate-[0.5deg]"
              >
                {/* Background image */}
                <img
                  src={event.image}
                  alt={event.title}
                  className="absolute inset-0 w-full h-full object-cover
                             transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />

                {/* Darker gradient overlay for better text readability */}
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal via-charcoal/70 to-charcoal/20" />

                {/* Orange border on hover */}
                <div className="absolute inset-0 rounded-xl border-2 border-transparent
                                group-hover:border-orange-vibrant/60 transition-colors duration-300" />

                {/* Content */}
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-charcoal/90 to-transparent">
                  <span className="text-2xl mb-1 block">{event.icon}</span>
                  <h3 className="font-display text-lg text-cream font-bold leading-tight drop-shadow-lg">
                    {event.title}
                  </h3>
                  <p className="text-sm text-cream/90 mt-1 line-clamp-2 drop-shadow-md">
                    {event.description}
                  </p>
                </div>
              </Link>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventTypeCards;
